
























































import { CommerceKindParams } from '@/store/interfaces/commerceKind';
import uploadIcon from '@/components/Reusable/uploadLogo.vue';
import { BlobImage } from '@/store/interfaces/BlobImage';
import { ValidationProvider } from 'vee-validate';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'FormCommerceKind',
  components: {
    uploadIcon,
  },
  props: {
    commerceKind: {
      required: false,
      type: Object as PropType<CommerceKindParams>,
    },
    clean: {
      required: false,
      type: Boolean,
      default: false,
    },
    loading: {
      required: true,
      type: Boolean,
    },
  },
  data: () => ({
    name: '',
    icon: '',
    iconFile: null,
    updateIcon: false,
  }),
  computed: {
    loadingSynced: {
      get(): boolean {
        return this.loading;
      },
      set(val: boolean): void {
        this.$emit('update:loading', val);
      },
    },
  },
  methods: {
    cancel(): void {
      this.$data.updateIcon = false;
      this.$emit('cancel', true);
    },
    allowedUpdateIcon(): void {
      this.$data.updateIcon = !this.$data.updateIcon;
    },
    sendData(): void {
      this.$emit('commerceKind', {
        icon: this.$data.icon,
        iconFile: this.$data.iconFile,
        name: this.$data.name,
      });
    },
    infoIconUpload(icon: BlobImage): void {
      this.$data.icon = icon;
    },
  },
  watch: {
    clean(value: boolean): void {
      if (value) {
        this.$data.name = '';
        this.$data.icon = '';
        this.$data.iconFile = null;
        this.$data.updateIcon = false;
        (
          this.$refs.formNewCommerceKind as InstanceType<
            typeof ValidationProvider
          >
        ).reset();
      }
    },
    commerceKind(commerce_kind: CommerceKindParams): void {
      if (commerce_kind) {
        this.$data.name = commerce_kind.name;
      } else {
        this.$data.name = '';
      }
    },
  },
});
